import { render, staticRenderFns } from "./TiposDiseniosABM.vue?vue&type=template&id=708c3237&"
import script from "./TiposDiseniosABM.vue?vue&type=script&lang=js&"
export * from "./TiposDiseniosABM.vue?vue&type=script&lang=js&"
import style0 from "./TiposDiseniosABM.vue?vue&type=style&index=0&id=708c3237&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports